/**
 * Release feature flags.
 *
 * V1.0 ships free-only: every paid plan surface (Pro / Elite / Club, upgrade
 * CTAs, subscription screens, payment copy) is hidden behind this flag while
 * the whole plan architecture stays intact in the codebase and the database.
 * Flipping this to `true` re-enables the existing screens with no other change.
 */
export const PAID_PLANS_ENABLED = false;

/** Convenience alias used by UI that only needs to know if billing surfaces show. */
export const BILLING_UI_ENABLED = PAID_PLANS_ENABLED;
